import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Line, Bar, Doughnut, Radar } from 'react-chartjs-2';
import {  FaUserGraduate, FaUsers, FaProjectDiagram, FaHandHoldingHeart,
  FaBriefcase, FaCalendarAlt, FaBars, FaCog, FaBell,
  FaEnvelope, FaTachometerAlt,  FaUserTie,
  FaAward,FaBuilding,FaTimes
} from 'react-icons/fa';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { FaPlus } from 'react-icons/fa';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  Filler
);

// Dummy data for the institute
const instituteData = {
  name: 'Government Engineering College, Gandhinagar',
  logo: 'https://i.ibb.co/xmvzY0d/image.png', // Adjusted for GEC Gandhinagar logo
  established: 2004, // Year GEC Gandhinagar was established
  location: 'Gandhinagar, Gujarat, India',
  website: 'www.gecg28.ac.in', // GEC Gandhinagar official website
  description: 'Government Engineering College, Gandhinagar is a reputed engineering institute in Gujarat, known for its commitment to technical excellence, innovation, and research across various fields of engineering.',
  stats: {
    students: 3000, // Approximate student count for GEC Gandhinagar
    alumni: 8000,  // Approximate alumni count
    faculty: 150,  // Faculty size at GEC Gandhinagar
    courses: 30,   // Number of courses offered
    research_centers: 3 // Number of research centers
  }
};


  const CreateEventForm = ({ onClose, onSubmit }) => {
    const [eventData, setEventData] = useState({
      title: '',
      date: '',
      time: '',
      location: '',
      category: '',
      description: '',
      deadline: '',
      ticketPrice: '',
      virtual: false,
      speakers: '',
      attendeeLimit: ''
    });
  
    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setEventData(prevData => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value
      }));
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit(eventData);
    };
  
    return (
      <motion.div
        initial={{ x: '100%' }}
        animate={{ x: 0 }}
        exit={{ x: '100%' }}
        transition={{ type: 'tween', duration: 0.3 }}
        className="fixed inset-y-0 right-0 w-full sm:w-96 bg-white shadow-lg flex flex-col"
      >
        <div className="p-6 flex-grow overflow-y-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">Create New Event</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <FaTimes size={24} />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="title">
                Event Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={eventData.title}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter event title"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="date">
                  Date
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={eventData.date}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="time">
                  Time
                </label>
                <input
                  type="time"
                  id="time"
                  name="time"
                  value={eventData.time}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="location">
                Location
              </label>
              <input
                type="text"
                id="location"
                name="location"
                value={eventData.location}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter event location"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="category">
                Category
              </label>
              <select
                id="category"
                name="category"
                value={eventData.category}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Category</option>
                <option value="Networking">Networking</option>
                <option value="Educational">Educational</option>
                <option value="Career">Career</option>
                <option value="Social">Social</option>
                <option value="Workshop">Workshop</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="description">
                Description
              </label>
              <textarea
                id="description"
                name="description"
                value={eventData.description}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="4"
                placeholder="Enter event description"
              ></textarea>
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="deadline">
                Registration Deadline
              </label>
              <input
                type="date"
                id="deadline"
                name="deadline"
                value={eventData.deadline}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="ticketPrice">
                Ticket Price
              </label>
              <input
                type="text"
                id="ticketPrice"
                name="ticketPrice"
                value={eventData.ticketPrice}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter ticket price or 'Free'"
              />
            </div>
            <div>
              <label className="flex items-center text-gray-700 text-sm font-bold">
                <input
                  type="checkbox"
                  name="virtual"
                  checked={eventData.virtual}
                  onChange={handleChange}
                  className="mr-2"
                />
                Virtual Event
              </label>
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="speakers">
                Speakers (comma-separated)
              </label>
              <input
                type="text"
                id="speakers"
                name="speakers"
                value={eventData.speakers}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="e.g. John Doe, Jane Smith"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="attendeeLimit">
                Attendee Limit
              </label>
              <input
                type="number"
                id="attendeeLimit"
                name="attendeeLimit"
                value={eventData.attendeeLimit}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter maximum number of attendees"
              />
            </div>
          </form>
        </div>
        <div className="p-6 bg-gray-100 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition duration-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-300"
          >
            Create Event
          </button>
        </div>
      </motion.div>
    );
  };
// Dummy data for charts
const alumniGrowthData = {
  labels: ['2018', '2019', '2020', '2021', '2022', '2023'],
  datasets: [{
    label: 'Alumni Network Growth',
    data: [30000, 35000, 40000, 43000, 47000, 50000],
    borderColor: 'rgb(75, 192, 192)',
    tension: 0.1,
    fill: true,
    backgroundColor: 'rgba(75, 192, 192, 0.2)',
  }]
};

const employmentRateData = {
  labels: ['Employed', 'Further Studies', 'Job Seeking'],
  datasets: [{
    data: [75, 15, 10],
    backgroundColor: ['#4CAF50', '#2196F3', '#FFC107'],
  }]
};

const researchFundingData = {
  labels: ['2018', '2019', '2020', '2021', '2022', '2023'],
  datasets: [{
    label: 'Research Funding (Millions $)',
    data: [50, 60, 75, 90, 100, 120],
    backgroundColor: 'rgba(54, 162, 235, 0.5)',
  }]
};

const topIndustriesData = {
  labels: ['Technology', 'Finance', 'Healthcare', 'Education', 'Manufacturing'],
  datasets: [{
    label: 'Alumni by Industry',
    data: [30, 25, 20, 15, 10],
    backgroundColor: [
      'rgba(255, 99, 132, 0.8)',
      'rgba(54, 162, 235, 0.8)',
      'rgba(255, 206, 86, 0.8)',
      'rgba(75, 192, 192, 0.8)',
      'rgba(153, 102, 255, 0.8)',
    ],
  }]
};

const InstituteDashboard = () => {
    const [activeSection, setActiveSection] = useState('overview');
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [createEventOpen, setCreateEventOpen] = useState(false);
    const [createJobOpen, setCreateJobOpen] = useState(false);
    const [createCampaignOpen, setCreateCampaignOpen] = useState(false);
    const [donationForm, setDonationForm] = useState({ isOpen: false, campaign: null });
    const [userDonations, setUserDonations] = useState([]);
  
    const handleCreateCampaign = (newCampaign) => {
      // Here you would typically send the new campaign to your backend
      // For now, we'll just log it and close the form
      console.log('New campaign created:', newCampaign);
      setCreateCampaignOpen(false);
    };
  
    const handleDonate = (campaign) => {
      setDonationForm({ isOpen: true, campaign: campaign });
    };
  
    const handleDonationSubmit = (campaignId, amount) => {
      console.log(`Donating ₹${amount} to campaign: ${campaignId}`);
      setUserDonations([...userDonations, campaignId]);
      // Here you would update the campaign's current amount and supporters
      setDonationForm({ isOpen: false, campaign: null });
    };
  const handleCreateJob = (newJob) => {
    // Here you would typically send the new job to your backend
    // For now, we'll just log it and close the form
    console.log('New job created:', newJob);
    setCreateJobOpen(false);
  };
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
  
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    const toggleSidebar = () => {
      setSidebarOpen(!sidebarOpen);
    };
  
    const sidebarItems = [
      { id: 'overview', label: 'Overview', icon: FaTachometerAlt },
      { id: 'alumni', label: 'Alumni', icon: FaUserGraduate },
      { id: 'students', label: 'Students', icon: FaUsers },
      { id: 'projects', label: 'Projects', icon: FaProjectDiagram },
      { id: 'campaigns', label: 'Campaigns', icon: FaHandHoldingHeart },
      { id: 'jobs', label: 'Jobs', icon: FaBriefcase },
      { id: 'events', label: 'Events', icon: FaCalendarAlt },
    ];
  
    const handleCreateEvent = (newEvent) => {
      // Here you would typically send the new event to your backend
      // For now, we'll just log it and close the form
      console.log('New event created:', newEvent);
      setCreateEventOpen(false);
    };
  const renderSection = () => {
    switch (activeSection) {
      case 'overview':
        return renderOverview();
      case 'alumni':
        return renderAlumni();
      case 'students':
        return renderStudents();
      case 'projects':
        return renderProjects();
      case 'campaigns':
        return renderCampaigns();
      case 'jobs':
        return renderJobs();
      case 'events':
        return renderEvents();
      default:
        return renderOverview();
    }
  };

  const renderOverview = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="col-span-1 md:col-span-2 lg:col-span-3 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-4">Institute Overview</h2>
        <div className="flex flex-col md:flex-row items-center md:items-start">
          <img src={instituteData.logo} alt="University Logo" className="w-32 h-32 object-contain mb-4 md:mb-0 md:mr-6" />
          <div>
            <h3 className="text-xl font-semibold">{instituteData.name}</h3>
            <p className="text-gray-600 mb-2">Established: {instituteData.established}</p>
            <p className="text-gray-600 mb-2">Location: {instituteData.location}</p>
            <p className="text-gray-600 mb-4">Website: <a href={`https://${instituteData.website}`} className="text-blue-500 hover:underline">{instituteData.website}</a></p>
            <p className="text-gray-700">{instituteData.description}</p>
          </div>
        </div>
      </div>

      {Object.entries(instituteData.stats).map(([key, value]) => (
        <div key={key} className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold mb-2 capitalize">{key.replace('_', ' ')}</h3>
          <p className="text-3xl font-bold text-blue-600">{value.toLocaleString()}</p>
        </div>
      ))}

      <div className="col-span-1 md:col-span-2 bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Alumni Network Growth</h3>
        <div className={chartContainerStyle}>
        <Line data={alumniGrowthData} options={{responsive: true, maintainAspectRatio: false}} className="h-64" />

      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Graduate Employment Rate</h3>
        <div className={chartContainerStyle}>
        <Doughnut data={employmentRateData} options={{responsive: true, maintainAspectRatio: false}} className="h-64" />
      </div>
      </div>

      <div className="col-span-1 md:col-span-2 bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Research Funding</h3>
        <div className={chartContainerStyle}>
        <Bar data={researchFundingData} options={{responsive: true, maintainAspectRatio: false}} className="h-64" />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Top Industries for Alumni</h3>
        <div className={chartContainerStyle}>
        <Doughnut data={topIndustriesData} options={{responsive: true, maintainAspectRatio: false}} className="h-64" />
      </div>
      </div>
    </div>
  );

  const renderAlumni = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="col-span-1 md:col-span-2 lg:col-span-3 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-4">Alumni Network</h2>
        <p className="text-gray-700 mb-4">Our alumni network consists of {instituteData.stats.alumni.toLocaleString()} graduates spread across the globe, making significant impacts in various industries.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Name</th>
                <th className="py-2 px-4 text-left">Graduation Year</th>
                <th className="py-2 px-4 text-left">Current Position</th>
                <th className="py-2 px-4 text-left">Company</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-2 px-4">Kaurani Divya</td>
                <td className="py-2 px-4">2023</td>
                <td className="py-2 px-4">Software Engineer</td>
                <td className="py-2 px-4">York IE</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-2 px-4">Mayank Yadav</td>
                <td className="py-2 px-4">2023</td>
                <td className="py-2 px-4">Software Engineer</td>
                <td className="py-2 px-4">Einfochips</td>
              </tr>
              <tr>
                <td className="py-2 px-4">Poojan Gethiya</td>
                <td className="py-2 px-4">2020</td>
                <td className="py-2 px-4">Product Manager</td>
                <td className="py-2 px-4">TCS</td>
              </tr>
              <tr>
                <td className="py-2 px-4">Jaimin Gajera</td>
                <td className="py-2 px-4">2020</td>
                <td className="py-2 px-4">Backend Developer</td>
                <td className="py-2 px-4">TCS</td>
              </tr>
              <tr>
                <td className="py-2 px-4">Khushi Gandhi</td>
                <td className="py-2 px-4">2020</td>
                <td className="py-2 px-4">Wordpress Developer</td>
                <td className="py-2 px-4">Brainspot</td>
              </tr>
              <tr>
                <td className="py-2 px-4">Khushi Sompura</td>
                <td className="py-2 px-4">2020</td>
                <td className="py-2 px-4">Project Manager</td>
                <td className="py-2 px-4">TCS</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Alumni by Graduation Year</h3>
        <div className={chartContainerStyle}>
        <Bar 
          data={{
            labels: ['2018', '2019', '2020', '2021', '2022', '2023'],
            datasets: [{
              label: 'Number of Alumni',
              data: [800, 850, 900, 950, 1000, 1050],
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
            }]
          }} 
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Global Alumni Distribution</h3>
        <div className={chartContainerStyle}>
        <Doughnut
          data={{
            labels: ['North America', 'Europe', 'Asia', 'Africa', 'South America', 'Australia'],
            datasets: [{
              data: [40, 25, 20, 5, 5, 5],
              backgroundColor: [
                'rgba(255, 99, 132, 0.8)',
                'rgba(54, 162, 235, 0.8)',
                'rgba(255, 206, 86, 0.8)',
                'rgba(75, 192, 192, 0.8)',
                'rgba(153, 102, 255, 0.8)',
                'rgba(255, 159, 64, 0.8)',
              ],
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Alumni Achievements</h3>
        <ul className="space-y-2">
          <li className="flex items-center"><FaAward className="text-yellow-500 mr-2" /> 25 CEOs of Fortune 500 companies</li>
          <li className="flex items-center"><FaAward className="text-yellow-500 mr-2" /> 100+ Startup founders</li>
          <li className="flex items-center"><FaAward className="text-yellow-500 mr-2" /> 50+ Patents filed</li>
          <li className="flex items-center"><FaAward className="text-yellow-500 mr-2" /> 10 Nobel laureates</li>
        </ul>
      </div>
    </div>
  );

  const renderStudents = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="col-span-1 md:col-span-2 lg:col-span-3 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-4">Student Body</h2>
        <p className="text-gray-700 mb-4">Our diverse student body consists of {instituteData.stats.students.toLocaleString()} students from various backgrounds and nationalities.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Program</th>
                <th className="py-2 px-4 text-left">Students Enrolled</th>
                <th className="py-2 px-4 text-left">Average GPA</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-2 px-4">Computer Science</td>
                <td className="py-2 px-4">2500</td>
                <td className="py-2 px-4">3.7</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-2 px-4">Electrical Engineering</td>
                <td className="py-2 px-4">2000</td>
                <td className="py-2 px-4">3.6</td>
              </tr>
              <tr>
                <td className="py-2 px-4">Business Administration</td>
                <td className="py-2 px-4">1800</td>
                <td className="py-2 px-4">3.5</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Student Demographics</h3>
        <div className={chartContainerStyle}>
        <Doughnut
          data={{
            labels: ['Domestic', 'International'],
            datasets: [{
              data: [70, 30],
              backgroundColor: ['rgba(54, 162, 235, 0.8)', 'rgba(255, 99, 132, 0.8)'],
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Student Satisfaction</h3>
        <div className={chartContainerStyle}>
        <Bar
          data={{
            labels: ['Academics', 'Facilities', 'Campus Life', 'Career Services'],
            datasets: [{
              label: 'Satisfaction Score (out of 5)',
              data: [4.5, 4.2, 4.7, 4.3],
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              y: {
                beginAtZero: true,
                max: 5,
              }
            }
          }}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Student Achievements</h3>
        <ul className="space-y-2">
          <li className="flex items-center"><FaAward className="text-yellow-500 mr-2" /> 50+ Hackathon winners</li>
          <li className="flex items-center"><FaAward className="text-yellow-500 mr-2" /> 25 Research paper publications</li>
          <li className="flex items-center"><FaAward className="text-yellow-500 mr-2" /> 10 National competition winners</li>
          <li className="flex items-center"><FaAward className="text-yellow-500 mr-2" /> 5 International olympiad medalists</li>
        </ul>
      </div>
    </div>
  );

  const renderProjects = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="col-span-1 md:col-span-2 lg:col-span-3 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-4">Research Projects</h2>
        <p className="text-gray-700 mb-4">Our institution is at the forefront of cutting-edge research across various disciplines.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Project Name</th>
                <th className="py-2 px-4 text-left">Department</th>
                <th className="py-2 px-4 text-left">Lead Researcher</th>
                <th className="py-2 px-4 text-left">Funding</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-2 px-4">AI for Climate Change</td>
                <td className="py-2 px-4">Computer Science</td>
                <td className="py-2 px-4">Dr. Jane Smith</td>
                <td className="py-2 px-4">$2.5M</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-2 px-4">Quantum Computing Algorithms</td>
                <td className="py-2 px-4">Physics</td>
                <td className="py-2 px-4">Dr. Michael Johnson</td>
                <td className="py-2 px-4">$3.2M</td>
              </tr>
              <tr>
                <td className="py-2 px-4">Sustainable Energy Solutions</td>
                <td className="py-2 px-4">Engineering</td>
                <td className="py-2 px-4">Dr. Emily Chen</td>
                <td className="py-2 px-4">$1.8M</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Research Funding by Department</h3>
        <div className={chartContainerStyle}>
        <Doughnut
          data={{
            labels: ['Computer Science', 'Engineering', 'Physics', 'Biology', 'Business'],
            datasets: [{
              data: [30, 25, 20, 15, 10],
              backgroundColor: [
                'rgba(255, 99, 132, 0.8)',
                'rgba(54, 162, 235, 0.8)',
                'rgba(255, 206, 86, 0.8)',
                'rgba(75, 192, 192, 0.8)',
                'rgba(153, 102, 255, 0.8)',
              ],
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Research Output</h3>
        <div className={chartContainerStyle}>
        <Bar
          data={{
            labels: ['2018', '2019', '2020', '2021', '2022', '2023'],
            datasets: [{
              label: 'Publications',
              data: [50, 65, 75, 90, 100, 120],
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Ongoing Projects</h3>
        <ul className="space-y-2">
          <li className="flex items-center"><FaProjectDiagram className="text-blue-500 mr-2" /> AI-driven Drug Discovery</li>
          <li className="flex items-center"><FaProjectDiagram className="text-blue-500 mr-2" /> Smart City Infrastructure</li>
          <li className="flex items-center"><FaProjectDiagram className="text-blue-500 mr-2" /> Blockchain for Supply Chain</li>
          <li className="flex items-center"><FaProjectDiagram className="text-blue-500 mr-2" /> Renewable Energy Storage</li>
        </ul>
      </div>
    </div>
  );
  const CreateCampaignForm = ({ onClose, onSubmit }) => {
    const [campaignData, setCampaignData] = useState({
      title: '',
      description: '',
      goalAmount: '',
      endDate: '',
      category: '',
      image: ''
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setCampaignData(prevData => ({ ...prevData, [name]: value }));
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit(campaignData);
    };
  
    return (
      <motion.div
        initial={{ x: '100%' }}
        animate={{ x: 0 }}
        exit={{ x: '100%' }}
        transition={{ type: 'tween', duration: 0.3 }}
        className="fixed inset-y-0 right-0 w-full sm:w-96 bg-white shadow-lg flex flex-col"
      >
        <div className="p-6 flex-grow overflow-y-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">Create New Campaign</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <FaPlus className="transform rotate-45" size={24} />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="title">
                Campaign Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={campaignData.title}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter campaign title"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="description">
                Description
              </label>
              <textarea
                id="description"
                name="description"
                value={campaignData.description}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="4"
                placeholder="Enter campaign description"
              ></textarea>
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="goalAmount">
                Goal Amount ($)
              </label>
              <input
                type="number"
                id="goalAmount"
                name="goalAmount"
                value={campaignData.goalAmount}
                onChange={handleChange}
                required
                min="0"
                step="0.01"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter goal amount"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="endDate">
                End Date
              </label>
              <input
                type="date"
                id="endDate"
                name="endDate"
                value={campaignData.endDate}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="category">
                Category
              </label>
              <select
                id="category"
                name="category"
                value={campaignData.category}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Category</option>
                <option value="Education">Education</option>
                <option value="Research">Research</option>
                <option value="Environment">Environment</option>
                <option value="Health">Health</option>
                <option value="Community">Community</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="image">
                Campaign Image URL
              </label>
              <input
                type="url"
                id="image"
                name="image"
                value={campaignData.image}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter image URL"
              />
            </div>
          </form>
        </div>
        <div className="p-6 bg-gray-100 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition duration-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-300"
          >
            Create Campaign
          </button>
        </div>
      </motion.div>
    );
  };
  const DonationForm = ({ campaign, onClose, onDonate }) => {
    const [amount, setAmount] = useState('');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onDonate(campaign.id, parseFloat(amount));
      onClose();
    };
  
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4"
      >
        <motion.div
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.9 }}
          className="bg-white rounded-lg p-6 w-full max-w-md"
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold">Donate to {campaign.title}</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <FaTimes size={24} />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="amount">
                Donation Amount (₹)
              </label>
              <input
                type="number"
                id="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
                min="1"
                step="1"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter donation amount"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition duration-300"
            >
              Confirm Donation
            </button>
          </form>
        </motion.div>
      </motion.div>
    );
  };
  const renderCampaigns = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="col-span-1 md:col-span-2 lg:col-span-3 bg-white rounded-lg shadow-md p-6">
      <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setCreateCampaignOpen(true)}
            className="bg-green-500 text-white px-4 py-2 rounded-lg flex items-center shadow-md hover:bg-green-600 transition duration-300"
          >
            <FaPlus className="mr-2" /> Create Campaign
          </motion.button>
          <AnimatePresence>
        {createCampaignOpen && (
          <CreateCampaignForm
            onClose={() => setCreateCampaignOpen(false)}
            onSubmit={handleCreateCampaign}
          />
        )}
        {donationForm.isOpen && (
          <DonationForm
            campaign={donationForm.campaign}
            onClose={() => setDonationForm({ isOpen: false, campaign: null })}
            onDonate={handleDonationSubmit}
          />
        )}
      </AnimatePresence>
        <h2 className="text-2xl font-bold mb-4">Fundraising Campaigns</h2>
        <p className="text-gray-700 mb-4">Our ongoing campaigns aim to support various initiatives and improvements across the university.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Campaign Name</th>
                <th className="py-2 px-4 text-left">Goal</th>
                <th className="py-2 px-4 text-left">Raised</th>
                <th className="py-2 px-4 text-left">Progress</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-2 px-4">New Science Center</td>
                <td className="py-2 px-4">$50M</td>
                <td className="py-2 px-4">$35M</td>
                <td className="py-2 px-4">
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-blue-600 h-2.5 rounded-full" style={{width: '70%'}}></div>
                  </div>
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-2 px-4">Scholarship Fund</td>
                <td className="py-2 px-4">$10M</td>
                <td className="py-2 px-4">$8M</td>
                <td className="py-2 px-4">
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-blue-600 h-2.5 rounded-full" style={{width: '80%'}}></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="py-2 px-4">Research Grant Program</td>
                <td className="py-2 px-4">$25M</td>
                <td className="py-2 px-4">$15M</td>
                <td className="py-2 px-4">
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-blue-600 h-2.5 rounded-full" style={{width: '60%'}}></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Donation Sources</h3>
        <div className={chartContainerStyle}>
        <Doughnut
          data={{
            labels: ['Alumni', 'Corporations', 'Foundations', 'Other'],
            datasets: [{
              data: [40, 30, 20, 10],
              backgroundColor: [
                'rgba(255, 99, 132, 0.8)',
                'rgba(54, 162, 235, 0.8)',
                'rgba(255, 206, 86, 0.8)',
                'rgba(75, 192, 192, 0.8)',
              ],
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Fundraising Growth</h3>
        <div className={chartContainerStyle}>
        <Line
          data={{
            labels: ['2018', '2019', '2020', '2021', '2022', '2023'],
            datasets: [{
              label: 'Total Funds Raised (Millions $)',
              data: [20, 25, 30, 40, 50, 60],
              borderColor: 'rgb(75, 192, 192)',
              tension: 0.1,
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Top Donors</h3>
        <ul className="space-y-2">
          <li className="flex items-center justify-between">
            <span><FaUserTie className="inline-block mr-2 text-blue-500" /> John Doe</span>
            <span className="font-semibold">$5M</span>
          </li>
          <li className="flex items-center justify-between">
            <span><FaBuilding className="inline-block mr-2 text-blue-500" /> Tech Corp Inc.</span>
            <span className="font-semibold">$3M</span>
          </li>
          <li className="flex items-center justify-between">
            <span><FaUserTie className="inline-block mr-2 text-blue-500" /> Jane Smith</span>
            <span className="font-semibold">$2M</span>
          </li>
        </ul>
      </div>
    </div>
  );
  const CreateJobForm = ({ onClose, onSubmit }) => {
    const [jobData, setJobData] = useState({
      title: '',
      company: '',
      location: '',
      salary: '',
      type: '',
      description: '',
      skills: []
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setJobData(prevData => ({ ...prevData, [name]: value }));
    };
  
    const handleSkillChange = (e) => {
      const skills = e.target.value.split(',').map(skill => skill.trim());
      setJobData(prevData => ({ ...prevData, skills }));
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit(jobData);
    };
  
    return (
      <motion.div
        initial={{ x: '100%' }}
        animate={{ x: 0 }}
        exit={{ x: '100%' }}
        transition={{ type: 'tween', duration: 0.3 }}
        className="fixed inset-y-0 right-0 w-full sm:w-96 bg-white shadow-lg flex flex-col"
      >
        <div className="p-6 flex-grow overflow-y-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">Create New Job</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <FaTimes size={24} />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="title">
                Job Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={jobData.title}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter job title"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="company">
                Company
              </label>
              <input
                type="text"
                id="company"
                name="company"
                value={jobData.company}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter company name"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="location">
                Location
              </label>
              <input
                type="text"
                id="location"
                name="location"
                value={jobData.location}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter job location"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="salary">
                Salary Range
              </label>
              <input
                type="text"
                id="salary"
                name="salary"
                value={jobData.salary}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="e.g. $80,000 - $120,000"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="type">
                Job Type
              </label>
              <select
                id="type"
                name="type"
                value={jobData.type}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Job Type</option>
                <option value="Full-time">Full-time</option>
                <option value="Part-time">Part-time</option>
                <option value="Contract">Contract</option>
                <option value="Internship">Internship</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="description">
                Job Description
              </label>
              <textarea
                id="description"
                name="description"
                value={jobData.description}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="4"
                placeholder="Enter job description"
              ></textarea>
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="skills">
                Skills Required (comma-separated)
              </label>
              <input
                type="text"
                id="skills"
                name="skills"
                value={jobData.skills.join(', ')}
                onChange={handleSkillChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="e.g. JavaScript, React, Node.js"
              />
            </div>
          </form>
        </div>
        <div className="p-6 bg-gray-100 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition duration-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-300"
          >
            Create Job
          </button>
        </div>
      </motion.div>
    );
  };
  
  const renderJobs = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="col-span-1 md:col-span-2 lg:col-span-3 bg-white rounded-lg shadow-md p-6">
      <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setCreateJobOpen(true)}
            className="bg-blue-500 text-white px-4 py-2 rounded-lg flex items-center shadow-md hover:bg-blue-600 transition duration-300"
          >
            <FaPlus className="mr-2" /> Post a Job
          </motion.button>
          <AnimatePresence>
        {createJobOpen && (
          <CreateJobForm
            onClose={() => setCreateJobOpen(false)}
            onSubmit={handleCreateJob}
          />
        )}
      </AnimatePresence>
        <h2 className="text-2xl font-bold mb-4">Job Opportunities</h2>
        <p className="text-gray-700 mb-4">Browse the latest job openings for our students and alumni.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Position</th>
                <th className="py-2 px-4 text-left">Company</th>
                <th className="py-2 px-4 text-left">Location</th>
                <th className="py-2 px-4 text-left">Salary Range</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-2 px-4">Software Engineer</td>
                <td className="py-2 px-4">Google</td>
                <td className="py-2 px-4">Mountain View, CA</td>
                <td className="py-2 px-4">$120k - $180k</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-2 px-4">Data Scientist</td>
                <td className="py-2 px-4">Amazon</td>
                <td className="py-2 px-4">Seattle, WA</td>
                <td className="py-2 px-4">$110k - $160k</td>
              </tr>
              <tr>
                <td className="py-2 px-4">Product Manager</td>
                <td className="py-2 px-4">Microsoft</td>
                <td className="py-2 px-4">Redmond, WA</td>
                <td className="py-2 px-4">$130k - $190k</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Job Postings by Industry</h3>
        <div className={chartContainerStyle}>
        <Doughnut
          data={{
            labels: ['Technology', 'Finance', 'Healthcare', 'Education', 'Manufacturing'],
            datasets: [{
              data: [40, 25, 15, 10, 10],
              backgroundColor: [
                'rgba(255, 99, 132, 0.8)',
                'rgba(54, 162, 235, 0.8)',
                'rgba(255, 206, 86, 0.8)',
                'rgba(75, 192, 192, 0.8)',
                'rgba(153, 102, 255, 0.8)',
              ],
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Job Placement Rate</h3>
        <div className={chartContainerStyle}>
        <Bar
          data={{
            labels: ['2018', '2019', '2020', '2021', '2022', '2023'],
            datasets: [{
              label: 'Placement Rate (%)',
              data: [92, 94, 93, 95, 96, 97],
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              y: {
                beginAtZero: true,
                max: 100,
              }
            }
          }}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Top Recruiting Companies</h3>
        <ul className="space-y-2">
          <li className="flex items-center justify-between">
            <span><FaBuilding className="inline-block mr-2 text-blue-500" /> Google</span>
            <span className="font-semibold">50 hires</span>
          </li>
          <li className="flex items-center justify-between">
            <span><FaBuilding className="inline-block mr-2 text-blue-500" /> Amazon</span>
            <span className="font-semibold">45 hires</span>
          </li>
          <li className="flex items-center justify-between">
            <span><FaBuilding className="inline-block mr-2 text-blue-500" /> Microsoft</span>
            <span className="font-semibold">40 hires</span>
          </li>
          <li className="flex items-center justify-between">
            <span><FaBuilding className="inline-block mr-2 text-blue-500" /> Apple</span>
            <span className="font-semibold">35 hires</span>
          </li>
        </ul>
      </div>
    </div>
  );

  const renderEvents = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="col-span-1 md:col-span-2 lg:col-span-3 bg-white rounded-lg shadow-md p-6">
      <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setCreateEventOpen(true)}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg flex items-center shadow-md hover:bg-blue-600 transition duration-300"
        >
          <FaPlus className="mr-2" /> Create Event
        </motion.button>
        <AnimatePresence>
          {createEventOpen && (
            <CreateEventForm
              onClose={() => setCreateEventOpen(false)}
              onSubmit={handleCreateEvent}
            />
          )}
        </AnimatePresence>
        <h2 className="text-2xl font-bold mb-4">Upcoming Events</h2>
        <p className="text-gray-700 mb-4">Stay updated with the latest events and activities at our institution.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Event Name</th>
                <th className="py-2 px-4 text-left">Date</th>
                <th className="py-2 px-4 text-left">Location</th>
                <th className="py-2 px-4 text-left">Type</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="py-2 px-4">Annual Alumni Reunion</td>
                <td className="py-2 px-4">Oct 15, 2024</td>
                <td className="py-2 px-4">Main Campus</td>
                <td className="py-2 px-4">Networking</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="py-2 px-4">Tech Innovation Summit</td>
                <td className="py-2 px-4">Nov 5, 2024</td>
                <td className="py-2 px-4">Conference Center</td>
                <td className="py-2 px-4">Conference</td>
              </tr>
              <tr>
                <td className="py-2 px-4">Career Fair 2024</td>
                <td className="py-2 px-4">Sep 20, 2024</td>
                <td className="py-2 px-4">Student Center</td>
                <td className="py-2 px-4">Career</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Event Attendance</h3>
        <div className={chartContainerStyle}>
        <Bar
          data={{
            labels: ['Alumni Reunion', 'Tech Summit', 'Career Fair', 'Hackathon', 'Graduation'],
            datasets: [{
              label: 'Attendees',
              data: [500, 1000, 1500, 300, 2000],
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Event Categories</h3>
        <div className={chartContainerStyle}>
        <Doughnut
          data={{
            labels: ['Networking', 'Academic', 'Career', 'Cultural', 'Sports'],
            datasets: [{
              data: [30, 25, 20, 15, 10],
              backgroundColor: [
                'rgba(255, 99, 132, 0.8)',
                'rgba(54, 162, 235, 0.8)',
                'rgba(255, 206, 86, 0.8)',
                'rgba(75, 192, 192, 0.8)',
                'rgba(153, 102, 255, 0.8)',
              ],
            }]
          }}
          options={{responsive: true, maintainAspectRatio: false}}
          className="h-64"
        />
      </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Featured Events</h3>
        <ul className="space-y-2">
          <li className="flex items-center">
            <FaCalendarAlt className="text-blue-500 mr-2" />
            <span>Annual Hackathon - Nov 15-17, 2024</span>
          </li>
          <li className="flex items-center">
            <FaCalendarAlt className="text-blue-500 mr-2" />
            <span>Guest Lecture Series - Every Tuesday</span>
          </li>
          <li className="flex items-center">
            <FaCalendarAlt className="text-blue-500 mr-2" />
            <span>Spring Music Festival - Apr 5-7, 2025</span>
          </li>
        </ul>
      </div>
    </div>
  );
  const chartContainerStyle = "h-64 md:h-80";

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <AnimatePresence>
        {(sidebarOpen || !isMobile) && (
          <motion.div
            initial={isMobile ? { x: "-100%" } : false}
            animate={{ x: 0 }}
            exit={isMobile ? { x: "-100%" } : false}
            transition={{ type: "tween" }}
            className={`bg-white text-gray-800 shadow-lg ${
              isMobile ? 'fixed inset-y-0 left-0 z-50 w-64' : 'w-64'
            }`}
          >
            <div className="p-6">
              <div className="mb-8 flex justify-between items-center">
                <h1 className="text-2xl font-bold">LDRP Dashboard</h1>
                {isMobile && (
                  <button onClick={toggleSidebar} className="text-gray-600 hover:text-gray-800">
                    <FaTimes size={24} />
                  </button>
                )}
              </div>
              <nav>
                <ul className="space-y-2">
                  {sidebarItems.map((item) => (
                    <li key={item.id}>
                      <button
                        onClick={() => {
                          setActiveSection(item.id);
                          if (isMobile) toggleSidebar();
                        }}
                        className={`flex items-center w-full p-2 rounded ${
                          activeSection === item.id ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'
                        }`}
                      >
                        <item.icon className="mr-2" />
                        {item.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main content */}
      <div className="flex-1 overflow-y-auto p-8">
  <header className="bg-white shadow-md p-4">
    <div className="flex justify-between items-center">
      <div className="flex items-center">
        {isMobile && (
          <button 
            onClick={toggleSidebar} 
            className="mr-4 bg-white p-2 rounded-full shadow-md text-gray-600 hover:text-gray-800 focus:outline-none"
          >
            <FaBars size={24} />
          </button>
        )}
        <h1 className="text-3xl font-bold">
          {sidebarItems.find(item => item.id === activeSection)?.label}
        </h1>
      </div>
      <div className="flex space-x-4">
        <button className="text-gray-600 hover:text-gray-800"><FaBell size={24} /></button>
        <button className="text-gray-600 hover:text-gray-800"><FaEnvelope size={24} /></button>
        <button className="text-gray-600 hover:text-gray-800"><FaCog size={24} /></button>
      </div>
    </div>
  </header>
  {renderSection()}
</div>
    </div>
  );
};

export default InstituteDashboard;